module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_7042.c20d062e.png";